module.exports = __webpack_public_path__ + "img/Hamburger.c8f20830.svg";